import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

import { IStateOffers } from "@/apps/merchant3/models/IStateOffers";

export default {
  namespaced: true,
  state: {
    deviceFamilies: {},
    selectedFamilyModels: {},

    recommendedOffers: {},

    deviceFamiliesDropdown: [],
    deviceModelsDropdown: [],

    prManufacturerDropdown: [],
    prOffers: [],

    selectedManufacturerObject: {},
    selectedDeviceFamilyObject: {},
    selectedDeviceModelObject: {},

    selectedDeviceFamily: [],
    selectedDeviceModel: [],
    selectedCartAccessory: {},
    selectedManufacturer: [],

    selectedDeviceImageUrl: "",
    pricing: [],
    offerErrorMessage: "",

    selfServiceOffers: [],
  } as unknown as IStateOffers,
  mutations,
  actions,
  getters,
};
